/* eslint-disable no-script-url, jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "@amzn/awsui-components-react-v3";

interface InfoLinkProps {
  onClick: () => void;
}

const InfoLink: React.FC<InfoLinkProps> = ({ onClick }): JSX.Element => {
  return (
    <Link variant="info" onFollow={onClick}>
      Info
    </Link>
  );
};

export default InfoLink;
